import React, { useEffect } from 'react';
import '../styles/common.css';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';


console.log('[VendorHome] 読み込み');

const VendorHome = ({ userId, companyName, fullName, managementAddress, onSignOut }) => {
  console.log('[VendorHome] コンポーネント呼び出し');
  const navigate = useNavigate();

  useEffect(() => {
    console.log('[VendorHome] 表示 OK');
    console.log('[VendorHome] userId:', userId);
    console.log('[VendorHome] companyName:', companyName);
    console.log('[VendorHome] fullName:', fullName);
    console.log('[VendorHome] managementAddress:', managementAddress);

    const now = Date.now();
    const loginTimeKey = 'loginTime';
    const threeDays = 3 * 24 * 60 * 60 * 1000;

    localStorage.setItem(loginTimeKey, now.toString());

    const timeout = setTimeout(async () => {
      await signOut();
      localStorage.removeItem(loginTimeKey);
      alert('セッションが途切れたため、再度ログインしてください。');
      window.location.href = '/license';
    }, threeDays);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="container">
      <div className="header">
        <div></div>
        <div className="user-info">
          <div>{companyName}<br />{fullName} 様</div>
          <button className="button button-blue" onClick={() => {
            localStorage.removeItem('loginTime');
            onSignOut();
          }}>ログアウト</button>
        </div>
      </div>

      <h1 className="title">ライセンス情報</h1>

      <div className="button-vertical-group">
        <div className="action-button" onClick={() => navigate('/license/new-request', { state: { userId, companyName, fullName, managementAddress } })}>
          <div className="action-title-purple">新規申請</div>
          <div className="action-desc">新規のお客様または、既存のお客様で別のメールアドレスを追加する場合はこちらから。</div>
        </div>

        <div className="action-button" onClick={() => navigate('/license/orders', { state: { companyName } })}>
          <div className="action-title-purple">申請一覧（更新・追加）</div>
          <div className="action-desc">終了日の更新または、ライセンス数の変更、過去の申請を確認する場合はこちらから。</div>
        </div>
      </div>

    </div>
  );
};

export default VendorHome;
